import React from 'react';
import { ProductImportTemplate } from 'themes/modules/product/pages';
import { inject, observer } from 'mobx-react';

@inject(i => ({
	productListViewStore: i.rootStore.productListViewStore,
}))
@observer
class ProductImport extends React.Component {
	render() {
		return <ProductImportTemplate {...this.props} />;
	}
}

export default ProductImport;
